import { get } from 'lodash';
import React from 'react';
import { getLocalstorageToken } from 'src/context/AuthHelper';
import { ANTRAG_VERBUNDPARTNER } from 'src/lib/constants/componentsPath';
import { KOSTENTRAEGER } from 'src/lib/constants/constant';
import EigenmittelAntragLogMob, { getFormStrucEigenmittelAntragLogMob } from './EigenmittelAntragLogMob';

// import schemas
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = Schema.attributes;

export const GetEigenmittelAntragLogMob = (application: any, hasCommentAusgabenUndFinanzierung?: boolean) => {
	const OrgaStruc = [
		{
			label: get(application, P.Antragstellende_Organisa_0074063902_licher_Name_Der_Organisation.path, `Antragsteller`),
			content: (
				<>
					<EigenmittelAntragLogMob
						kostentraeger={KOSTENTRAEGER.Antragsteller}
						unternehmenId={get(getLocalstorageToken(), 'organisationId')}
						institutionsTyp={get(application, P.Organisation_Antragsberechtigt_Als.path)}
						hasComment={hasCommentAusgabenUndFinanzierung}
					/>
				</>
			),
			formStruc: getFormStrucEigenmittelAntragLogMob(application, get(getLocalstorageToken(), 'organisationId')),
		},
	];
	const PartnerStruc = get(application, P.Verbundpartner.path, []).map((ele: any, i: number) => {
		return {
			label: get(
				ele,
				Schema.attributes.Verbundpartner.schema.attributes.Verbundpartner.schema.attributes.Geschaeftsbezogene_Daten_Name_Der_Organisation.path.slice(
					P.Verbundpartner.path.length + 1,
				),
				`Verbundpartner ${i + 1}`,
			),
			content: (
				<EigenmittelAntragLogMob
					kostentraeger={KOSTENTRAEGER.Verbundpartner}
					unternehmenId={get(ele, 'Verbundpartner.id')}
					institutionsTyp={get(ele, ANTRAG_VERBUNDPARTNER.Antragberechtigt)}
					hasComment={hasCommentAusgabenUndFinanzierung}
				/>
			),
			formStruc: getFormStrucEigenmittelAntragLogMob(application, get(ele, 'Verbundpartner.id')),
		};
	});

	return [...OrgaStruc, ...PartnerStruc];
};
